import { Eyebrow, MaskLines, Reveal } from "./Reveal";

export const Suppliers = () => (
  <section id="suppliers" data-testid="suppliers-section" className="border-t border-white/10 bg-[#0D1015] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-6">
        <Eyebrow>Trusted suppliers</Eyebrow>
        <h2 className="font-display text-5xl font-black uppercase leading-[0.9] text-white sm:text-6xl lg:text-7xl">
          <MaskLines inView lines={["Quality materials.", <span key="b" className="text-blue-500">Proven brands.</span>]} />
        </h2>
        <Reveal>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg">
            A build is only as good as what goes into it. Owens Corning is one of our suppliers — their shingles go on the roofs we build, from a brand known for roofing, insulation and building materials trusted by contractors across the country.
          </p>
          <a
            href="https://www.owenscorning.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="owens-corning-link"
            className="btn-ghost mt-8"
          >
            Visit Owens Corning
          </a>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-6">
        <div className="grid gap-4">
          <div data-testid="owens-corning-logo-card" className="clip-corner group relative overflow-hidden bg-white p-6 sm:p-10">
            <img
              src="/images/oc-preferred.jpg"
              alt="Owens Corning Preferred Contractor badge with the Pink Panther"
              className="mx-auto aspect-[619/323] w-full object-contain transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <p className="mt-4 border-t border-black/10 pt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-700">Official badge · <span className="font-bold">Owens Corning Preferred Contractor</span></p>
          </div>
          <figure data-testid="owens-corning-shingles-photo" className="clip-corner group relative overflow-hidden bg-[#12161F]">
            <img
              src="/images/oc-shingles.jpg"
              alt="Roof with Owens Corning shingles"
              loading="lazy"
              className="aspect-[1438/900] w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
            />
            <figcaption className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white">Owens Corning shingles</figcaption>
          </figure>
        </div>
      </Reveal>
    </div>
  </section>
);
